import { memo } from 'react';
import { TrafficRuleProperties } from './trafficRules';
import { LogicalSpace } from '@thive/fddm-types';

interface Props {
  selectedLogicalSpaces: LogicalSpace[];
}

function LogicalSpaceParametersComponent({ selectedLogicalSpaces }: Props) {
  if (selectedLogicalSpaces.length === 0) {
    return null;
  }

  return <TrafficRuleProperties logicalSpaces={selectedLogicalSpaces} />;
}

export const LogicalSpaceParameters = memo(LogicalSpaceParametersComponent);
